import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { ToastMessagesComponent } from './components/toasts/components/toast-messages/toast-messages.component';
import { filter, Subject, takeUntil } from 'rxjs';
import { UserService } from '@inera/common';
import { SessionService } from './services/session.service';
import { AppFooterComponent } from './components/app-footer/app-footer.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppHeaderComponent, ToastMessagesComponent, AppFooterComponent],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy, OnInit {
  title = 'idp-client-tools';

  private currentPath: string = '';
  private destroy$ = new Subject<boolean>();

  constructor(
    private router: Router,
    private userService: UserService,
    private sessionService: SessionService
  ) {
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(e => {
        this.currentPath = (e as NavigationEnd).url;

        this.userService.getUser().subscribe(user => {
          this.sessionService.setUser(user);
        });
      });
  }

  ngOnInit(): void {
    this.userService.getUser().subscribe(
      user => {
        this.sessionService.setUser(user);
      },
      error => {
        if (error.error.code === 2001) {
          this.router.navigate(['_error'], {
            queryParams: {
              status: error.error.code,
              datetime: new Date().toISOString(),
            },
          });
        }
      }
    );
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public showHeaderAndFooter(): boolean {
    return !this.currentPath.toLowerCase().includes('theme/builder');
  }
}
